import { connect } from 'react-redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import config from '~/config';
import { formatCondensedHumanDate } from '~/DateTime';
import { buildGroupInitialUrl, selectUpdate } from '~/ProductGroup';
import { State } from '~/Store';

import Item from './Item';

function mapStateToProps(
	state: State,
	props: {
		productGroup: UserProductGroup;
	}
): {
	currency: string;
	link: { pathname: string; search: string };
	isUpdatingNotification: boolean;
	formatDate: (date: Date, includeYear: boolean, locale: string[]) => string;
} {
	return {
		currency: config.product.defaultPriceCurrency,
		link: buildGroupInitialUrl(props.productGroup, state),
		isUpdatingNotification: selectUpdate(state.productGroup, props.productGroup.id) !== null,
		formatDate: formatCondensedHumanDate,
	};
}

export default connect(mapStateToProps)(Item);
